export default __webpack_public_path__ + "static/click-and-collect-c84f693a24e6c30ae8046fafa4511df6.svg";